import { render } from "./InputDiscount.vue?vue&type=template&id=d3097768"
import script from "./InputDiscount.vue?vue&type=script&lang=js"
export * from "./InputDiscount.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__